<template>
  <b-container fluid>
    <b-row>
      <b-col
        v-if="!isCreateView"
        class="mb-2"
        cols="12"
      >
        <b-row>
          <b-col
            cols="auto"
            class="mr-auto"
          />
          <b-col
            class="text-right"
            cols="auto"
          >
            <b-button
              variant="success"
              class="mr-2"
              @click="submit"
            >
              ออกเอกสาร
            </b-button>
            <b-button @click="close">
              ย้อนกลับ
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="auto"
        class="mr-auto"
      >
        <h5 class="text-left">
          {{ hospital }}
        </h5>
      </b-col>
      <b-col
        cols="auto"
        class="text-right"
      >
        <b-row>
          <b-col class="mt-1">
            วันที่ออกเอกสาร
          </b-col>
          <b-col>
            <b-form-input
              :value="dateInvoice"
              :disabled="true"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col cols="10">
        <b-row>
          <b-col
            v-for="(documentType, index) in numberList"
            :key="index"
            cols="6"
            class="mt-1"
          >
            <b-row>
              <b-col>
                <label
                  :for="`number-${documentType.id}`"
                >เลขที่{{
                  documentType.document
                }}</label>
              </b-col>
              <b-col>
                <b-form-input
                  v-model="numberList[index].number"
                  :disabled="isCreateView"
                  @change="changeNumber"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <confirm-add-document-table-modal
        v-if="corporationType ==='corporation'"
        class="table-modal"
        :orders.sync="orders"
        :is-create-view="isCreateView"
      />
      <confirm-add-other-platform-document-table-modal
        v-else
        class="table-modal"
        :is-create-view="isCreateView"
        :orders.sync="orders"
      />
    </b-row>
    <b-row>
      <b-col
        cols="12"
        class="p-0"
      >
        <add-document-footer :data="orders" />
      </b-col>
    </b-row>
    <b-row v-if="isCreateView">
      <b-col
        v-for="document in documents"
        :key="document.id"
      >
        <b-button
          block
          class="printed-btn"
        >
          พิมพ์{{ document.document_name }}
        </b-button>
      </b-col>
      <b-col>
        <b-button
          block
          class="pdf-download-btn"
        >
          ดาวน์โหลดเป็น PDF
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import ConfirmAddDocumentTableModal from "../../components/Account/ConfirmAddDocumentTableModal";
  import ConfirmAddOtherPlatformDocumentTableModal from "../../components/Account/ConfirmAddOtherPlatformDocumentTableModal"
  import AddDocumentFooter from "../../components/Account/AddDocumentFooter"

  export default {
    name: "ConfirmAddDocument",
    components: {
      ConfirmAddDocumentTableModal,
      AddDocumentFooter,
      ConfirmAddOtherPlatformDocumentTableModal
    },
    props: {
      dateInvoice: {},
      invoiceNumber: {
        type: String
      },
      orders: {
        type: Array
      },
      hospital: {
        type: String
      },
      numbers: {
        type: Array
      },
      submit: {
        type: Function
      },
      close: {
        type: Function
      },
      corporationType: {
        type: String
      },
      isCreateView: {
        type: Boolean
      },
      documents: {
        type: Array
      }
    },
    computed: {
      ...mapGetters({
        documentTypes: "Account/getFilterDocumentType"
      })
    },
    created() {
      for (let documentType of this.documentTypes) {
        if (documentType.has_number) {
          this.numberList.push({
            number: this.invoiceNumber,
            document: documentType.name,
            document_id: documentType.id
          });
        }
      }
      this.$emit("update:numbers", this.numberList);
    },
    data() {
      return {
        numberList: []
      };
    },
    methods: {
      changeNumber() {
        this.$emit("update:numbers", this.numberList);
      }
    }
  };
</script>

<style lang="scss" scoped>
    .table-modal {
        /*max-height: 400px;*/
        width:100%;
        overflow-y: auto;
    }
    .printed-btn {
        background-color: #fd881e;
        border: none;
        height: 100%;
    }

    .pdf-download-btn {
        background-color: #2e83d9;
        border: none;
        height: 100%;
    }
</style>
